module.exports = __webpack_public_path__ + "static/media/39_ThorstenTeriete_webfinal.2376dfc2.jpg";